jQuery(function($){
	adjustPixelHeightWidth();
	$(window).on('resize', function(){
		adjustPixelHeightWidth();
	});

	function adjustPixelHeightWidth() {
		console.log('adjusting');
		$('.pixel-width').each(function(){
			const el = this;
			el.style.width = 'initial';
			setTimeout(function(){
				var prevWidth = el.getBoundingClientRect().width;
				var newWidth = Math.ceil(prevWidth);
				el.style.width = newWidth + 'px';
			}, 50);
		});
		$('.pixel-height').each(function(){
			const el = this;
			el.style.height = 'initial';
			setTimeout(function(){
				var prevHeight = el.getBoundingClientRect().height;
				var newHeight = Math.ceil(prevHeight);
				el.style.height = newHeight + 'px';
			}, 50);
		});
	}
});